export const destroy = () => {
  window.Beacon?.('destroy');
};
